import { z } from 'zod';
import { FieldValueSchema } from './schema';
export const JSONValueSchema = FieldValueSchema.nullable().optional();
export const EnrichmentFieldConfigurationSchema = z.intersection(z.object({
    type: z.string()
}), z.record(z.string(), JSONValueSchema));
//# sourceMappingURL=enrichment.js.map